import { defineStore } from "pinia";
import type { Dashboard } from "../domain/dashboard";
import { useEntityStore } from 'shared/common/composables/entityStore';

export const useDashboardStore = defineStore('dashboards', () => {

  const {
    add,
    clear,
    getById,
    merge,
    remove,
    list
  } = useEntityStore<Dashboard>({
    eventName: 'dashboard-changed',
    getEntityId: (e) => e.id,
    updateEntity: (dest, src) => {
      dest.name = src.name;
      dest.components = src.components;
    }
  });

  return {
    add,
    clear,
    getById,
    merge,
    remove,
    list
  };
});
